import {CONFIG_SET_BINDINGTYPES ,CONFIG_SET_REGIONS} from '../actions/configActions'

let initialState ={
    bindingTypes:null,
    regions:null,
}

export default function config(state=initialState,action){
    switch (action.type){
        case CONFIG_SET_BINDINGTYPES:
            return{
            ...state,
            bindingTypes:action.payload
        }
        case CONFIG_SET_REGIONS:
            return{
                ...state,
                regions:action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/config.js